import { render, staticRenderFns } from "./FilesSubmission.vue?vue&type=template&id=7055ba24&scoped=true&"
import script from "./FilesSubmission.vue?vue&type=script&lang=js&"
export * from "./FilesSubmission.vue?vue&type=script&lang=js&"
import style0 from "./FilesSubmission.vue?vue&type=style&index=0&id=7055ba24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055ba24",
  null
  
)

export default component.exports